import React from 'react';
import { ROBOTS } from '@lmp/eduki-routes';
import { Navigate, Route, createRoutesFromElements } from 'react-router-dom';
import PrivateRoute, { ROLE } from './common/private-route/private-route';
import Routes from './constants/routes';
import { PROFILE_TAB_URLS } from './routes/author/authour.constants';
import AsyncComponent from './routes/index';
import { DomainManager } from './utils/domain-manager';

const routes = createRoutesFromElements(
    <>
        <Route
            path={Routes.AUTHOR_DOMAIN_MATERIAL_PAGE.path}
            element={
                <DomainManager
                    domainComponent={
                        <AsyncComponent componentName='MaterialPage' meta={Routes.AUTHOR_DOMAIN_MATERIAL_PAGE.meta} />
                    }
                    originalComponent={<Navigate to={Routes.HOME.path} />}
                />
            }
        />
        <Route
            element={<AsyncComponent className='font-roboto-only' componentName='Jobs' meta={Routes.JOBS.meta} />}
            path={Routes.JOBS.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='ReferralsLanding' meta={Routes.REFERRAL_INCENTIVE_LANDING.meta} />
                </PrivateRoute>
            }
            path={Routes.REFERRAL_INCENTIVE_LANDING.path}
        />
        <Route
            path={Routes.SCHOOL_LANDING_PAGES.prefix}
            element={<AsyncComponent componentName='SchoolLandingPage' meta={Routes.SCHOOL_LANDING_PAGES.meta} />}
        />
        <Route
            path={Routes.SCHOOL_LANDING_PAGES.path}
            element={<AsyncComponent componentName='SchoolLandingPage' meta={Routes.SCHOOL_LANDING_PAGES.meta} />}
        />
        <Route
            path={Routes.SCHOOL_LANDING_PAGES.fullpath}
            element={
                <AsyncComponent
                    componentName='SwitchLandingComponent'
                    isSchoolLanding
                    meta={Routes.SCHOOL_LANDING_PAGES.meta}
                />
            }
        />
        <Route
            path={Routes.REFERRAL_INCENTIVE_LANDING_FOR_UNAUTHORIZED.path}
            element={
                <AsyncComponent
                    componentName='ReferralsLandingForUnauthorized'
                    meta={Routes.REFERRAL_INCENTIVE_LANDING_FOR_UNAUTHORIZED.meta}
                />
            }
        />
        <Route
            path={Routes.LMP_HISTORY.path}
            element={<AsyncComponent componentName='LMPHistory' meta={Routes.LMP_HISTORY.meta} />}
        />
        <Route
            path={Routes.OUR_TEAM.path}
            element={<AsyncComponent componentName='OurTeam' meta={Routes.OUR_TEAM.meta} />}
        />
        <Route
            path={Routes.MOBILE_APP_LANDING.path}
            element={<AsyncComponent componentName='MobileAppLanding' meta={Routes.MOBILE_APP_LANDING.meta} />}
        />
        <Route
            path={Routes.MENTAL_HEALTH_LANDING.path}
            element={<AsyncComponent componentName='MentalHealthLanding' meta={Routes.MENTAL_HEALTH_LANDING.meta} />}
        />
        <Route
            path={Routes.MENTAL_HEALTH_KIDS_LANDING.path}
            element={
                <AsyncComponent componentName='MentalHealthKidsLanding' meta={Routes.MENTAL_HEALTH_KIDS_LANDING.meta} />
            }
        />
        <Route
            path={Routes.RUSSIA_ATTACKS_UKRAINE_LANDING.path}
            element={
                <AsyncComponent
                    componentName='RussiaAttacksUkraineLanding'
                    meta={Routes.RUSSIA_ATTACKS_UKRAINE_LANDING.meta}
                />
            }
        />
        <Route
            path={Routes.CLIMATE_ACTION.path}
            element={<AsyncComponent componentName='ClimateAction' meta={Routes.CLIMATE_ACTION.meta} />}
        />
        <Route
            path={Routes.DONATE_UKRAINE.path}
            element={<AsyncComponent componentName='DonateUkraine' meta={Routes.DONATE_UKRAINE.meta} />}
        />
        <Route
            path={Routes.INCLUSION_CAMPAIGN.path}
            element={<AsyncComponent componentName='Inclusion' meta={Routes.INCLUSION_CAMPAIGN.meta} />}
        />
        <Route
            path={Routes.BUILDER_PREVIEW.path}
            element={<AsyncComponent componentName='BuilderPreview' meta={Routes.BUILDER_PREVIEW.meta} />}
        />
        <Route
            path={Routes.INTERACTIVE_MAIN_LANDING.path}
            element={
                <AsyncComponent componentName='InteractiveMainLanding' meta={Routes.INTERACTIVE_MAIN_LANDING.meta} />
            }
        />
        <Route
            path={Routes.CREATE_BLOGPOST.path}
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='CreateBlogpost' meta={Routes.CREATE_BLOGPOST.meta} />
                </PrivateRoute>
            }
        />
        <Route path={Routes.HOME.path} element={<AsyncComponent componentName='Home' meta={Routes.HOME.meta} />} />
        <Route
            path={Routes.BLOGPOST.path}
            element={<AsyncComponent componentName='Blogpost' meta={Routes.BLOGPOST.meta} />}
        />
        <Route
            path={Routes.FREE_MATERIALS_LANDING.path}
            element={<AsyncComponent componentName='FreeMaterialsLanding' meta={Routes.FREE_MATERIALS_LANDING.meta} />}
        />
        <Route
            path={Routes.SELLER.path}
            element={<AsyncComponent componentName='Seller' meta={Routes.SELLER.meta} />}
        />
        <Route
            path={Routes.TEILEN.path}
            element={<AsyncComponent componentName='Seller' meta={Routes.SELLER.meta} />}
        />
        <Route
            path={Routes.AUTHORIZE.path}
            element={<AsyncComponent componentName='AutoLogin' meta={Routes.AUTHORIZE.meta} />}
        />
        <Route
            path={Routes.PARTNERS.path}
            element={<AsyncComponent componentName='Partners' meta={Routes.PARTNERS.meta} />}
        />
        <Route
            element={
                <DomainManager
                    domainComponent={
                        <AsyncComponent
                            componentName='Author'
                            meta={Routes.AUTHOR_MAIN.meta}
                            tab={PROFILE_TAB_URLS.MAIN}
                        />
                    }
                    originalComponent={<Navigate to={Routes.HOME.path} />}
                />
            }
            path={Routes.ENTRY_POINT.path}
        />
        <Route
            element={
                <DomainManager
                    domainComponent={
                        <AsyncComponent
                            componentName='Author'
                            meta={Routes.AUTHOR_MAIN.meta}
                            tab={PROFILE_TAB_URLS.MAIN}
                        />
                    }
                    originalComponent={<Navigate to={Routes.HOME.path} />}
                />
            }
            path={Routes.ENTRY_POINT.fullpathTab}
        />
        <Route
            element={
                <AsyncComponent componentName='Author' meta={Routes.AUTHOR_MAIN.meta} tab={PROFILE_TAB_URLS.MAIN} />
            }
            path={Routes.AUTHOR_MAIN.path}
        />
        <Route
            element={
                <AsyncComponent componentName='Author' meta={Routes.AUTHOR_MAIN.meta} tab={PROFILE_TAB_URLS.MAIN} />
            }
            path={Routes.AUTHOR_MAIN.fullpathTab}
        />
        <Route
            element={
                <AsyncComponent componentName='Author' meta={Routes.USER_PROFILE.meta} tab={PROFILE_TAB_URLS.MAIN} />
            }
            path={Routes.USER_PROFILE.path}
        />
        <Route
            element={
                <AsyncComponent componentName='Author' meta={Routes.USER_PROFILE.meta} tab={PROFILE_TAB_URLS.MAIN} />
            }
            path={Routes.USER_PROFILE.fullpath}
        />
        <Route
            element={
                <AsyncComponent componentName='Author' meta={Routes.USER_PROFILE.meta} tab={PROFILE_TAB_URLS.MAIN} />
            }
            path={Routes.USER_PROFILE.fullpathTab}
        />
        <Route
            path={`${Routes.LANDING.prefix}*`}
            element={<AsyncComponent componentName='SwitchLandingComponent' meta={Routes.LANDING.meta} />}
        />
        <Route
            path={Routes.LANDING.path}
            element={<AsyncComponent componentName='SwitchLandingComponent' meta={Routes.LANDING.meta} />}
        />
        <Route
            path={Routes.STIFTUNG_LANDING.path}
            element={<AsyncComponent isStiftung componentName='Landing' meta={Routes.STIFTUNG_LANDING.meta} />}
        />
        <Route
            path={Routes.KEYWORD_LANDING.path}
            element={<AsyncComponent componentName='KeywordLanding' meta={Routes.KEYWORD_LANDING.meta} />}
        />
        <Route
            path={Routes.SALE_LANDING.path}
            element={<AsyncComponent isSale componentName='Landing' meta={Routes.SALE_LANDING.meta} />}
        />
        <Route
            path={Routes.MATERIAL.path}
            element={<AsyncComponent componentName='MaterialPage' meta={Routes.MATERIAL.meta} />}
        />
        <Route
            path={Routes.MATERIAL_CARD_PREVIEW.path}
            element={<AsyncComponent componentName='MaterialCardPreview' meta={Routes.MATERIAL_CARD_PREVIEW.meta} />}
        />
        <Route
            path={Routes.IMPACT_PAGE.path}
            element={<AsyncComponent componentName='ImpactPage' meta={Routes.IMPACT_PAGE.meta} />}
        />
        <Route
            path={Routes.GDPR_JOBS.defaultPath}
            element={<AsyncComponent componentName='GdprJobs' meta={Routes.GDPR_JOBS.meta} />}
        />
        <Route
            path={Routes.MATERIAL_FEEDBACK.path}
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='MaterialFeedback' meta={Routes.MATERIAL_FEEDBACK.meta} />
                </PrivateRoute>
            }
        />
        <Route
            path={Routes.WARENKORB.path}
            element={<AsyncComponent componentName='Cart' meta={Routes.WARENKORB.meta} />}
        />
        <Route
            path={Routes.PAYMENT.path}
            element={
                <AsyncComponent
                    componentName='Payment'
                    loadedReducers={[
                        {
                            key: 'payment',
                            path: 'payment/new'
                        }
                    ]}
                    meta={Routes.PAYMENT.meta}
                />
            }
        />
        <Route
            path={Routes.THANK_YOU_PAGE.path}
            element={<AsyncComponent componentName='ThankYouPage' meta={Routes.THANK_YOU_PAGE.meta} />}
        />
        <Route
            path={Routes.THANK_YOU_PAGE_INVOICE.path}
            element={<AsyncComponent componentName='ThankYouPageInvoice' meta={Routes.THANK_YOU_PAGE_INVOICE.meta} />}
        />
        <Route
            path={Routes.SEARCH_RESULT.path}
            element={<AsyncComponent componentName='SearchResult' meta={Routes.SEARCH_RESULT.meta} />}
        />
        <Route
            element={<AsyncComponent meta={Routes.STEPS_NAME.meta} componentName='SellerSteps' step={0} />}
            path={Routes.STEPS_NAME.path}
        />
        <Route
            element={<AsyncComponent componentName='SellerSteps' step={1} meta={Routes.STEPS_HOCHLADEN.meta} />}
            path={Routes.STEPS_HOCHLADEN.path}
        />
        <Route element={<AsyncComponent componentName='SignIn' meta={Routes.LOGIN.meta} />} path={Routes.LOGIN.path} />
        <Route
            element={<AsyncComponent componentName='SignUp' meta={Routes.SIGN_UP.meta} />}
            path={Routes.SIGN_UP.path}
        />
        <Route
            element={<AsyncComponent componentName='SignUpConfirm' meta={Routes.SIGN_UP_CONFIRM.meta} />}
            path={Routes.SIGN_UP_CONFIRM.path}
        />
        <Route
            element={<AsyncComponent componentName='ChangeEmailConfirm' meta={Routes.CHANGE_EMAIL_CONFIRM.meta} />}
            path={Routes.CHANGE_EMAIL_CONFIRM.path}
        />
        <Route
            element={<AsyncComponent componentName='HelpCenter' meta={Routes.HELP_CENTER.meta} />}
            path={Routes.HELP_CENTER.path}
        />
        <Route
            element={<AsyncComponent componentName='Impressum' meta={Routes.IMPRESSUM.meta} />}
            path={Routes.IMPRESSUM.path}
        />
        <Route element={<AsyncComponent componentName='Agb' meta={Routes.AGB.meta} />} path={Routes.AGB.path} />
        <Route
            element={<AsyncComponent componentName='ForgotPassword' meta={Routes.FORGOT_PASSWORD.meta} />}
            path={Routes.FORGOT_PASSWORD.path}
        />
        <Route
            element={<AsyncComponent componentName='Favorites' meta={Routes.FAVORITES.meta} />}
            path={Routes.FAVORITES.path}
        />
        <Route
            element={<AsyncComponent componentName='Unsubscribe' meta={Routes.UNSUBSCRIBE.meta} />}
            path={Routes.UNSUBSCRIBE.path}
        />
        <Route element={<AsyncComponent componentName='Api' meta={Routes.API.meta} />} path={Routes.API.path} />
        <Route
            element={<AsyncComponent componentName='MailingUnsubscribe' meta={Routes.MAILING_UNSUBSCRIBE.meta} />}
            path={Routes.MAILING_UNSUBSCRIBE.path}
        />
        <Route
            path={Routes.UNSUBSCRIBE_BY_LINK.path}
            element={<AsyncComponent isNew componentName='MailingUnsubscribe' meta={Routes.UNSUBSCRIBE_BY_LINK.meta} />}
        />
        <Route
            path={Routes.AUTHOR_UNSUBSCRIBE.path}
            element={<AsyncComponent componentName='UnsubscribeAuthor' meta={Routes.AUTHOR_UNSUBSCRIBE.meta} />}
        />
        <Route
            path={Routes.PASSWORD_RECOVERY.path}
            element={<AsyncComponent componentName='PasswordRecovery' meta={Routes.PASSWORD_RECOVERY.meta} />}
        />
        <Route
            path={Routes.FINISH_REGISTRATION.path}
            element={<AsyncComponent componentName='FinishRegistration' meta={Routes.FINISH_REGISTRATION.meta} />}
        />
        <Route
            path={Routes.FREE_DOWNLOAD.path}
            element={<AsyncComponent componentName='FreeDownload' meta={Routes.FREE_DOWNLOAD.meta} />}
        />
        <Route
            path={Routes.LOGIN_AS.path}
            element={<AsyncComponent componentName='LoginAs' meta={Routes.LOGIN_AS.meta} />}
        />
        <Route
            path={Routes.HOME_SCHOOLING.path}
            element={<AsyncComponent componentName='HomeSchooling' meta={Routes.HOME_SCHOOLING.meta} />}
        />
        <Route
            element={<AsyncComponent componentName='Podcasts' meta={Routes.PODCASTS.meta} />}
            path={Routes.PODCASTS.path}
        />
        <Route
            element={<AsyncComponent componentName='Magazine' meta={Routes.MAGAZINE.meta} />}
            path={Routes.MAGAZINE.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='AuthorRedirect' meta={Routes.AUTHOR_REDIRECT.meta} />
                </PrivateRoute>
            }
            path={Routes.AUTHOR_REDIRECT.path}
        />
        <Route
            element={
                <AsyncComponent componentName='AbandonedCartRedirect' meta={Routes.ABANDONED_CART_REDIRECT.meta} />
            }
            path={Routes.ABANDONED_CART_REDIRECT.path}
        />
        <Route
            element={<AsyncComponent componentName='MicrosoftRedirectURI' meta={Routes.MICROSOFT_REDIRECT_URI.meta} />}
            path={Routes.MICROSOFT_REDIRECT_URI.path}
        />
        <Route
            element={
                <AsyncComponent
                    componentName='FillPersonalizationRedirect'
                    meta={Routes.FILL_PERSONALIZATION_REDIRECT.meta}
                />
            }
            path={Routes.FILL_PERSONALIZATION_REDIRECT.path}
        />
        <Route
            element={<AsyncComponent componentName='AgroNordwest' meta={Routes.AGRO_NORDWEST.meta} />}
            path={Routes.AGRO_NORDWEST.path}
        />
        <Route
            element={<AsyncComponent componentName='AiTools' meta={Routes.AI_TOOLS.meta} />}
            path={Routes.AI_TOOLS.path}
        />
        <Route
            element={<AsyncComponent componentName='AiToolDocument' meta={Routes.AI_TOOL_DOCUMENT.meta} />}
            path={Routes.AI_TOOL_DOCUMENT.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='AiToolsMyDocuments' meta={Routes.AI_TOOLS_DOCUMENTS.meta} />
                </PrivateRoute>
            }
            path={Routes.AI_TOOLS_DOCUMENTS.path}
        />
        <Route
            element={<AsyncComponent componentName='AiToolsFaq' meta={Routes.AI_TOOLS_FAQ.meta} />}
            path={Routes.AI_TOOLS_FAQ.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='AiToolPage' meta={Routes.AI_TOOL_PAGE.meta} />
                </PrivateRoute>
            }
            path={Routes.AI_TOOL_PAGE.path}
        />

        <Route element={<AsyncComponent componentName='Nps' meta={Routes.NPS.meta} />} path={Routes.NPS.path} />
        <Route
            element={<AsyncComponent componentName='schoolAccount' meta={Routes.SCHOOL_ACCOUNT.meta} />}
            path={Routes.SCHOOL_ACCOUNT.path}
        />
        <Route
            element={<AsyncComponent componentName='SchoolCreate' meta={Routes.SCHOOL_CREATE.meta} />}
            path={Routes.SCHOOL_CREATE.path}
        />
        <Route
            element={<AsyncComponent componentName='NewInteractive' meta={Routes.NEW_INTERACTIVE_MAIN.meta} />}
            path={`${Routes.NEW_INTERACTIVE_MAIN.path}/*`}
        />
        <Route
            element={
                <AsyncComponent componentName='BackToSchool2025TC' meta={Routes.BACK_TO_SCHOOL_CAMPAIGN_TC.meta} />
            }
            path={Routes.BACK_TO_SCHOOL_CAMPAIGN_TC.path}
        />
        <Route
            element={
                <AsyncComponent
                    componentName='BackToSchool2025Landing'
                    meta={Routes.BACK_TO_SCHOOL_CAMPAIGN_LANDING.meta}
                />
            }
            path={Routes.BACK_TO_SCHOOL_CAMPAIGN_LANDING.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='Fonts' meta={Routes.FONTS.meta} />
                </PrivateRoute>
            }
            path={Routes.FONTS.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='MySchool' meta={Routes.MY_SCHOOL.meta} />
                </PrivateRoute>
            }
            path={Routes.MY_SCHOOL.path}
        />
        <Route
            element={
                <PrivateRoute access={ROLE.MEMBER}>
                    <AsyncComponent componentName='SchoolWishlist' meta={Routes.SCHOOL_WISHLIST.meta} />
                </PrivateRoute>
            }
            path={Routes.SCHOOL_WISHLIST.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='PreferenceCenter' meta={Routes.CABINET_PREFERENCE_CENTER.meta} />
                </PrivateRoute>
            }
            path={Routes.CABINET_PREFERENCE_CENTER.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='DownloadsList' meta={Routes.BOUGHT_MATERIALS.meta} />
                </PrivateRoute>
            }
            path={Routes.BOUGHT_MATERIALS.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='InvoicesAndTaxes' meta={Routes.INVOICES_AND_TAXES.meta} />
                </PrivateRoute>
            }
            path={Routes.INVOICES_AND_TAXES.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='BankDetails' meta={Routes.CABINET_BANK_DETAILS.meta} />
                </PrivateRoute>
            }
            path={Routes.CABINET_BANK_DETAILS.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='ChangePassword' meta={Routes.CABINET_CHANGE_PASSWORD.meta} />
                </PrivateRoute>
            }
            path={Routes.CABINET_CHANGE_PASSWORD.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='ChangeEmail' meta={Routes.CABINET_CHANGE_EMAIL.meta} />
                </PrivateRoute>
            }
            path={Routes.CABINET_CHANGE_EMAIL.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='ChangeCountry' meta={Routes.CHANGE_COUNTRY.meta} />
                </PrivateRoute>
            }
            path={Routes.CHANGE_COUNTRY.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='InvoiceInfo' meta={Routes.CABINET_INVOICE_INFO.meta} />
                </PrivateRoute>
            }
            path={Routes.CABINET_INVOICE_INFO.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='Recommendations' meta={Routes.SEASONAL_MATERIALS_LANDING.meta} />
                </PrivateRoute>
            }
            path={Routes.SEASONAL_MATERIALS_LANDING.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent
                        componentName='MyUploads'
                        meta={Routes.CABINET_SALES.meta}
                        loadedReducers={[
                            {
                                key: 'materialUpload',
                                path: 'cabinet/material-wizard'
                            },
                            {
                                key: 'bundle',
                                path: 'cabinet/bundle-wizard'
                            }
                        ]}
                    />
                </PrivateRoute>
            }
            path={Routes.CABINET_SALES.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='Vouchers' meta={Routes.VOUCHERS.meta} />
                </PrivateRoute>
            }
            path={Routes.VOUCHERS.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='Charts' meta={Routes.CHARTS.meta} />
                </PrivateRoute>
            }
            path={Routes.CHARTS.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='CreditNotes' meta={Routes.CREDIT_NOTES.meta} />
                </PrivateRoute>
            }
            path={Routes.CREDIT_NOTES.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='Credits' meta={Routes.CREDITS.meta} />
                </PrivateRoute>
            }
            path={Routes.CREDITS.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent componentName='MySales' meta={Routes.MY_SALES.meta} />
                </PrivateRoute>
            }
            path={Routes.MY_SALES.path}
        />
        <Route
            element={
                <PrivateRoute>
                    <AsyncComponent
                        firstUpload
                        componentName='Wizard'
                        meta={Routes.CABINET_UPLOAD.meta}
                        loadedReducers={[
                            {
                                key: 'materialUpload',
                                path: 'cabinet/material-wizard'
                            }
                        ]}
                    />
                </PrivateRoute>
            }
            path={Routes.CABINET_UPLOAD.path}
        />
        <Route
            path='*'
            element={<AsyncComponent componentName='NotFound' meta={() => ({ robots: ROBOTS.NOINDEX_FOLLOW })} />}
        />
    </>
);

export default routes;
